/**
 * Round a number to 3 significant figures for display.
 * @param value - The number to round.
 * @returns The rounded value as a string, e.g. '0.123'.
 */
export function formatSignificantFigures(value: number) {
  return `${parseFloat(value.toPrecision(3))}`
}
